import { PersonaMessages, useName } from '@bechtel/client-common';
import { Box, Text } from '@bechtel/gds';
import { CrewMember } from '@bechtel/types';
import { useLingui } from '@lingui/react';
import { FC } from 'react';
import { AvatarRegularStyled } from './styled';
interface CrewEmployeeItemProps {
  crewMember: CrewMember;
  crewNumber: string;
}
export const CrewEmployeeItem: FC<CrewEmployeeItemProps> = ({ crewMember, crewNumber }) => {
  const { getFullName } = useName();
  const { i18n } = useLingui();
  return (
    <Box flexGrow={{ sm: 1 }}>
      <Box>
        <AvatarRegularStyled src={crewMember?.imageUrl ? crewMember?.imageUrl : undefined} />
      </Box>
      <Box flexDirection={{ sm: 'column' }}>
        <Text weight="600" size="300" color="grey.1000" style={{ lineHeight: 1.5 }}>
          {getFullName(crewMember?.firstName, crewMember?.lastName)}
        </Text>
        <Text size="200" color="grey.600" transform="capitalize">
          {crewMember.subGroupDescription
            ? `${crewMember.subGroupDescription} - `
            : crewMember.persona
              ? `${i18n._(PersonaMessages[crewMember.persona])} -`
              : ''}
          {crewNumber}
        </Text>
        <Text size="200" color="grey.600">
          {crewMember.discipline}
        </Text>
      </Box>
    </Box>
  );
};
